import { type PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import {
  type PublicGlobalConfig,
  useGlobalConfigContext,
} from '../../../../../global-config'
import { priceAccessorGetDisplayPrice } from '../../../../model/priceAccessor/priceAccessorGetDisplayPrice'
import { priceAccessorIsDiscountValid } from '../../../../model/priceAccessor/priceAccessorIsDiscountValid'
import { productAccessorGetDiscountFromOffer } from '../../../../model/productAccessor/productAccessorGetDiscountFromOffer'
import { productAccessorGetOfferByIdOrDefault } from '../../../../model/productAccessor/productAccessorGetOfferByIdOrDefault'
import { type SelectionEntry } from '../../../product-page-context/AttributeGroup'

export const useSelectionSetAnyDiscountOrBonuses = ({
  currentPrescriptionType,
  discountBoundaries,
  isMarketplace,
  offerId,
  selectionEntries,
}: {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  discountBoundaries: PublicGlobalConfig['discountBoundaries']
  isMarketplace: boolean
  offerId: string | null
  selectionEntries: SelectionEntry[]
}): { hasAnyBonuses: boolean; hasAnyDiscounts: boolean } => {
  const { tenant } = useGlobalConfigContext()
  let hasAnyBonuses = false
  let hasAnyDiscounts = false

  selectionEntries.some((entry) => {
    const [currentVariant] = entry.allCandidateVariants

    const offer = productAccessorGetOfferByIdOrDefault({
      isMarketplace,
      offerId,
      offers: currentVariant.offers,
    })

    if (!offer) {
      return false
    }

    const displayPrice = priceAccessorGetDisplayPrice(
      offer,
      currentPrescriptionType,
    )

    const discount = productAccessorGetDiscountFromOffer({
      currentPrescriptionType,
      offer,
      tenant,
    })

    hasAnyBonuses ||= Boolean(displayPrice?.bonus)
    hasAnyDiscounts ||= Boolean(
      discount && priceAccessorIsDiscountValid(discount, discountBoundaries),
    )

    return hasAnyBonuses && hasAnyDiscounts
  })

  return { hasAnyBonuses, hasAnyDiscounts }
}
